import { useEffect, useRef } from "react";
import { useIntersection } from "react-use";

/**
 * Calls onLoadMore when the sentinel element intersects the viewport.
 * Uses a generous rootMargin so the next page starts loading before the user
 * reaches the end of the list.
 *
 * @param {{
 *   onLoadMore: () => void,
 *   enabled?: boolean,
 *   rootMargin?: string,
 * }} options
 */
const useInfiniteScrollSentinel = ({
	onLoadMore,
	enabled = true,
	rootMargin = "600px 0px",
} = {}) => {
	const sentinelRef = useRef(null);
	const entry = useIntersection(sentinelRef, {
		root: null,
		rootMargin,
		threshold: 0,
	});

	const isIntersecting = Boolean(entry?.isIntersecting);

	useEffect(() => {
		if (!enabled || !isIntersecting) return;
		onLoadMore?.();
	}, [enabled, isIntersecting, onLoadMore]);

	return sentinelRef;
};

export default useInfiniteScrollSentinel;
